import * as S from "./ExerciseList.style";
import { Buttons } from "@/components/atoms/Buttons";
import { useState } from "react";
import { useNavigate } from "react-router";
import { ExerciseItem } from "@/components/atoms/ExerciseItem";
import { ExerciseCategory } from "@/common/types/video";
import { ReactComponent as IconArrow } from "@/styles/assets/svg/icon_arrow_rt_color.svg";

interface ExerciseListProps {
  exerciseCategories: ExerciseCategory[];
  exercisePointEligibility?: any;
}

export const ExerciseList = ({
  exerciseCategories,
  exercisePointEligibility,
}: ExerciseListProps) => {
  const navigate = useNavigate();
  const [exerciseModalShow, setExerciseModalShow] = useState(false);

  const handleExerciseConfirm = (result: boolean) => {
    if (result) {
      navigate(`/exercise/set/1`);
    }
  };

  return (
    <>
      <S.ExerciseListBox>
        <S.ExerciseListTit>
          부위별 운동
          <Buttons
            type="button"
            size="more"
            layout="text"
            color="primary100"
            label="전체 보기"
            onClick={() => {
              // if (exercisePointEligibility?.points === 50000) {
              //   setExerciseModalShow(true);
              // } else {
              //   navigate(`/exercise/partby/READY`);
              // }
              navigate(`/exercise/partby/READY`);
            }}
          >
            <IconArrow width={22} height={22} />
          </Buttons>
        </S.ExerciseListTit>

        <S.ExerciseList>
          {exerciseCategories.map(
            (exerciseCategory: ExerciseCategory, idx: number) => {
              return (
                <ExerciseItem key={idx} exerciseCategory={exerciseCategory} />
              );
            }
          )}
        </S.ExerciseList>
      </S.ExerciseListBox>
      {/* {exerciseModalShow &&
        exercisePointEligibility &&
        exercisePointEligibility?.points === 50000 && (
          <ModalExerciseConfirm
            setModalShow={setExerciseModalShow}
            onConfirm={handleExerciseConfirm}
            type="point"
          />
        )} */}
    </>
  );
};
